/**
 * Created by Bart Decorte
 * Date: 2019-07-09
 * Time: 09:28
 */

export default class CharacterLimiter {
  constructor() {
    this.$body = $('body');
    this.bindListeners();
    this.init();
  }

  init() {
    const $limiters = $('[data-limiter]');
    for (let i = 0; i < $limiters.length; i++) {
      this.calculate($($limiters[i]));
    }
  }

  bindListeners() {
    this.$body.on('input change', '[data-limiter]', (ev) => {
      return this.lValueChanged(ev);
    });
  }

  lValueChanged(ev) {
    const $elt = $(ev.target);
    this.calculate($elt);
    return this;
  }

  calculate($elt) {
    const value = $elt.val();
    const limit = parseInt($elt.data('limiter-limit'));
    const $limiter = $($elt.data('limiter'));
    const count = value.length;
    const remainder = limit - count;

    if (remainder > -1) {
      $limiter.text(remainder);
    } else {
      $limiter.text(0);
      $elt.val(value.substr(0, limit));
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/CharacterLimiter.js